var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleWarning = function SvgCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 29.8666C23.2495 29.8666 23.0046 29.9409 22.7963 30.0801C22.588 30.2193 22.4257 30.4171 22.3298 30.6486C22.2339 30.88 22.2089 31.1347 22.2577 31.3804C22.3066 31.6261 22.4272 31.8518 22.6044 32.029C22.7815 32.2061 23.0072 32.3268 23.2529 32.3756C23.4987 32.4245 23.7533 32.3994 23.9848 32.3036C24.2162 32.2077 24.4141 32.0453 24.5533 31.837C24.6924 31.6287 24.7667 31.3838 24.7667 31.1333C24.7667 30.7974 24.6333 30.4752 24.3957 30.2376C24.1582 30.0001 23.836 29.8666 23.5001 29.8666Z",
    fill: "#2E3330"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 27.2844V16.7157",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.5,
    r: 22.75,
    stroke: props.fill,
    strokeWidth: 1.5
  }));
};
export default SvgCircleWarning;